export default __webpack_public_path__ + "static/media/user.048ab605.svg";